import { FC, useEffect, useState } from "react";
import {
  Typography,
  Container,
  Link,
  Box,
  Grid,
  List,
  ListItem,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { FooterStyle } from "../Styles/LandingStyles";
import footerlogo from "../../assets/images/footerlogo.svg";
import discord from "../../assets/images/discord.svg";
import fb from "../../assets/images/Facebook.svg";
import insta from "../../assets/images/Instagram.svg";
import linkedin from "../../assets/images/linkedin.svg";
import twitter from "../../assets/images/twitter.svg";
import tiktok from "../../assets/images/tiktok.svg";
import AuditIcon from "../../assets/images/auditIcon.svg";
import AuditIconSecond from "../../assets/images/auditIcon2.svg";
import PeckShield from "../../assets/images/peckShield.svg";
import LegalNoteIcon from "../../assets/images/legalNoteIcon.svg";
import { Tooltip } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import BuyGainModel from "../Modals/BuyGainModel";
import { USDollar } from "../../utils/currency/usd";

const Footer: FC = () => {
  const classes = FooterStyle();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("md"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const [open, setOpen] = useState<boolean>(false);
  const [tokenPrice, setTokenPrice] = useState<number>(0);

  useEffect(() => {
    const fetchTokenPrice = async () => {
      const url = new URL("https://api.coingecko.com/api/v3/simple/price");
      url.searchParams.append("ids", "gains"); // Replace with the actual ID of the Gains token
      url.searchParams.append("vs_currencies", "usd");

      try {
        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        const data = await response.json();
        setTokenPrice(data.gains.usd);
      } catch (error) {
        console.error("Error fetching token price:", error);
      }
    };

    fetchTokenPrice();
  }, []);

  return (
    <>
      <Box className={classes.footer} component="footer">
        <Container fixed>
          <Grid container spacing={0}>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Box mb={isActive ? 3 : 0}>
                <NavLink to="/">
                  <img
                    src={footerlogo}
                    className="img-fluid"
                    width="150"
                    alt="Gains"
                  />
                </NavLink>
              </Box>
              <Box mb={isActive ? 3 : 0}>
                <Link
                  href="#"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  {" "}
                  Gains Ventures LLC
                </Link>
              </Box>
              <Box
                mb={isActive ? 3 : 0}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Link
                  href="#"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                  style={{
                    marginBottom: "0px",
                  }}
                >
                  {" "}
                  1 GAINS = {USDollar.format(tokenPrice)}
                </Link>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className="smallFontSize"
                  style={{
                    padding: "0px 8px 0px 8px",
                    marginLeft: "10px",
                    fontWeight: 100,
                  }}
                  onClick={() => setOpen(true)}
                >
                  Buy GAINS
                </Button>
              </Box>
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <Box ml={isActive ? 0 : 5}>
                <Typography variant="h6" color="textSecondary">
                  Company
                </Typography>
                {/* <Link
                  href="https://docs.google.com/document/d/1IpITeRd2aTVHvr3iT_sOROK8IrrJccnIo2TyyPRrel8/edit?usp=sharing"
                  target="_blank"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Careers
                </Link> */}
                <Link
                  href="https://www.gains-associates.com/about"
                  target="_blank"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  About
                </Link>
                <Link
                  href="https://drive.google.com/drive/u/3/folders/1OC5bfB7K1ylyCAJSJaFDzty_R835G90d?usp=sharing"
                  target="_blank"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Brand Assets
                </Link>
                <Link
                  href="https://forms.gle/v9KxY68crhE14nEb9"
                  target="_blank"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Submit your Project
                </Link>
              </Box>
            </Grid>
            <Grid item lg={1} md={1} sm={4}></Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <Box ml={isActive ? 0 : 10}>
                <Typography variant="h6" color="textSecondary">
                  Help
                </Typography>
                <Link
                  href="https://t.me/+tIwaCtq58KthMDQ8"
                  target="_blank"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Support
                </Link>
                <Link
                  href="https://www.gains-associates.com/privacy-policy"
                  target="_blank"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Privacy Policy
                </Link>
                <Link
                  href="/terms"
                  target="_blank"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Terms & Conditions
                </Link>
                {/* <Link
                  href={
                    require("../../assets/doc/GAINS-associates-deck.pdf")
                      .default
                  }
                  target="_blank"
                  rel="noopener"
                  variant="subtitle1"
                  color="textSecondary"
                >
                  Lightpaper
                </Link> */}
              </Box>
            </Grid>
            <Grid item lg={2} md={1} sm={4} xs={12}></Grid>
            <Grid item md={3} sm={12}>
              <Box mt={isActive ? 2 : 0}>
                <Typography variant="h6" color="textSecondary">
                  Follow us
                </Typography>
                <form noValidate autoComplete="off">
                  {/* <TextField
                    autoComplete="new-password"
                    InputLabelProps={{
                      classes: {
                        root: classes.cssLabel,
                        focused: classes.cssFocused,
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <KeyboardArrowRightIcon style={{ color: "#fff" }} />
                        </InputAdornment>
                      ),
                    }}
                    label="Enter Email"
                    variant="outlined"
                  /> */}
                </form>
                <List className={classes.socials} disablePadding={true}>
                  <ListItem dense={true} disableGutters={true}>
                    <Link
                      href="https://twitter.com/GainsAssociates"
                      target="_blank"
                      rel="noopener"
                    >
                      <Tooltip title="Twitter">
                        <img src={twitter} alt="Gains" />
                      </Tooltip>
                    </Link>
                    <Link
                      href="https://www.linkedin.com/company/gains-associates"
                      target="_blank"
                      rel="noopener"
                    >
                      <Tooltip title="LinkedIn">
                        <img src={linkedin} alt="Gains" />
                      </Tooltip>
                    </Link>
                  </ListItem>
                </List>
              </Box>
            </Grid>
          </Grid>
        </Container>
        <Box className={classes.copyright} component="div">
          <Container fixed>
            <Grid
              container
              justifyContent={isActiveXS ? "flex-start" : "center"}
            >
              <Grid item lg={10}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection={isActiveXS ? "column" : "row"}
                >
                  <Box mr={isActiveXS ? 0 : 4} className="gains-footer ">
                    <Typography
                      align={isActiveXS ? "left" : "center"}
                      variant="body2"
                      color="textSecondary"
                      className="mr-32"
                    >
                      {" "}
                      © Copyright {new Date().getFullYear()} GAINS Associates.
                      All rights reserved.
                    </Typography>
                  </Box>
                  <Box mr={1.5} display={"flex"} alignItems="center">
                    <Typography
                      align="center"
                      variant="body2"
                      color="textSecondary"
                      className="opacity-08 pr-12"
                    >
                      Audited By:
                    </Typography>
                    <Link
                      href="https://www.certik.com/projects/gainsassociates"
                      target="_blank"
                      rel="noopener"
                    >
                      <img src={AuditIcon} alt="Certik" className="mr-24" />
                    </Link>
                    <Link
                      href="https://hacken.io/audits/#gains_associates"
                      target="_blank"
                      rel="noopener"
                    >
                      <img
                        src={AuditIconSecond}
                        className="mr-24"
                        alt="Hacken"
                      />
                    </Link>
                    <Link
                      href="https://github.com/peckshield/publications/blob/master/audit_reports/PeckShield-Audit-Report-GAINS-v1.0.pdf"
                      target="_blank"
                      rel="noopener"
                    >
                      <img src={PeckShield} alt="Peck Shield" />
                    </Link>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Container fixed>
          <Grid container spacing={0}>
            <Grid item lg={1} md={2}>
              <Box pt={2} pb={2}>
                <Box display="flex">
                  <img src={LegalNoteIcon} alt="gains" />

                  <Box pl={1} mr={1.5}>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="textSecondary"
                      className=" fw-normal mb-0 opacity-08"
                    >
                      {" "}
                      Legal Note
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={11} md={10}>
              <Box pt={isActiveXS ? 0 : 2} pb={2}>
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                  className=" fw-normal mb-0 opacity-08"
                >
                  Participants/Citizens from the following countries are
                  strictly excluded/not allowed from the crowdfunding platform
                  and its services: Afghanistan, Albania, Barbados, Belarus,
                  Burkina Faso, Cambodia, Cameroon, Cayman Islands, Croatia,
                  Cuba, Democratic People’s Republic of Korea (North Korea),
                  Democratic Republic of the Congo, Gibraltar, Haiti, Iran,
                  Iraq, Jamaica, Jordan, Libya, Mali, Moldova, Morocco,
                  Mozambique, Myanmar, Nicaragua, Nigeria, Pakistan, Panama,
                  Philippines, Senegal, South Africa, Sudan, Syria, Tanzania,
                  Trinidad and Tobago, Turkey, Uganda, United Arab Emirates,
                  United States of America and any other U.S. possessions,
                  Vanuatu, Vietnam, Yemen, Zimbabwe, and the Russian Federation
                  (Russia, Crimea, Luhansk, Donetsk, etc.) (collectively
                  referred to as the "Prohibited Jurisdictions") according to
                  the Terms of Services.
                  <br />
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <BuyGainModel open={open} setOpen={setOpen} />
        </Container>
      </Box>
    </>
  );
};

export default Footer;
